import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { useI18n } from '@runtime/core/i18n/i18n'
import { HOME_ALIASES } from '@/routes/home/arrival/homeArrival'

const publicPages: Record<string, string> = {
  '/strategy': 'strategy',
  '/puzzle': 'puzzle',
  '/rules': 'rules',
  '/education': 'education',
  '/privacy': 'privacy',
}
export default function PlayMetadata() {
  const { pathname } = useLocation()
  const { t } = useI18n()
  const home = HOME_ALIASES.some(path => path === pathname) || /^\/p\/[^/]+$/.test(pathname)
  const page = home ? 'home' : publicPages[pathname]
  const title = page ? t('common.playNavigation.' + page) + ' · UNITED SQUARE' : 'UNITED SQUARE'
  const description = t('runtime.pageDescription')
  useEffect(() => {
    if (pathname.startsWith('/challenges/s/')) return
    document.head.querySelectorAll('[data-challenge-share]').forEach(element => element.remove())
    document.title = title
    for (const [name, content] of [
      ['description', description],
      ['robots', page ? 'index,follow' : 'noindex,nofollow'],
      ['og:title', title],
      ['og:description', description],
      ['og:type', 'website'],
    ]) {
      const property = name.startsWith('og:') ? 'property' : 'name'
      let meta = document.head.querySelector<HTMLMetaElement>(`meta[${property}="${name}"]`)
      if (!meta) {
        meta = document.createElement('meta')
        meta.setAttribute(property, name)
        document.head.append(meta)
      }
      meta.content = content
    }
    let canonical = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]')
    if (page) {
      if (!canonical) {
        canonical = document.createElement('link')
        canonical.rel = 'canonical'
        document.head.append(canonical)
      }
      canonical.href = 'https://play.united-square.com' + (home ? '/home' : pathname)
    } else canonical?.remove()
  }, [pathname, home, page, title, description])
  return null
}
